<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs }">
      <v-btn
        :loading="searching"
        @click="OpenDep"
        v-bind="attrs"
        color="error darken-2"
        small
        >Draw Capt
        <v-icon right>fas fa-hand-holding</v-icon>
      </v-btn>
    </template>

    <v-card width="500" class="mx-auto">
      <v-card-title primary-title class="error mb-3">
        Withdraw Capital in Cash
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-10">
        <v-form ref="MoneyDep">
          <BaseDate
            outlined
            label="Deposit Date"
            v-model="cashDep.date"
          ></BaseDate>
          <v-select
            outlined
            :loading="searching"
            v-model.trim="cashDep.CashAccount"
            :rules="[v => !!v || 'Cash Account is required']"
            :items="Cashes"
            item-text="AccountName"
            item-value="_id"
            label="Cash Account"
            prepend-inner-icon="fas fa-hand-holding-usd"
            required
            no-data-text="No Cash Account"
          ></v-select>
          <v-select
            outlined
            solo
            append-icon="fas fa-search-dollar"
            v-model.trim="cashDep.amountType"
            :items="GetCashTypes"
            :rules="[v => !!v || 'Cash Type is required']"
            label="Money Type"
            required
            no-data-text="Refresh the page"
          ></v-select>
          <BaseNumInput
            :rules="[paymentRule]"
            append-icon="fas fa-hand-holding-usd"
            outlined
            solo
            v-model.trim="cashDep.Amount"
            label="Deposit Amount"
          ></BaseNumInput>

          <v-text-field
            outlined
            solo
            append-icon="fas fa-comment"
            :rules="[v => !!v || 'Details is require']"
            name="DetailsDepositMoney"
            label="Info"
            id="DetailsDepositMoneyID"
            v-model="cashDep.Details"
          ></v-text-field>
        </v-form>
        <!-- <small class="text-center warning white--text d-block"
            >Note the Capital amount is based on
            <strong class="black--text">{{ UsersToken.CashBase }}</strong>
          </small> -->
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions class="px-10">
        <v-btn :loading="clicked" @click="OnDepMoney" color="success" block
          >Save Money</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    Onfinished: { type: Function, default: () => null },
  },
  data() {
    return {
      clicked: false,
      searching: false,
      dialog: false,
      ErrMsg: "",
      Cashes: [],
      cashDep: {
        CashAccount: "",
        amountType: "",
        Details: "",
        Amount: null,
        date: "",
        time: "",
      },
    };
  },
  computed: {
    ...mapGetters(["UsersToken", "GetCashTypes"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.CashAccount = "";
      this.PayDate = "";
      this.Details = "";
      this.Amount = 0;
      this.AccountBlce = 0;
      this.$refs.depositForm.resetValidation();
    },
    GetReq(url, query) {
      if (!url) url = "/Account";
      if (!query) query = { acc: [{ AccountType: 1 }, { AccountType: 3 }] };

      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenDep() {
      this.searching = true;
      this.GetReq()
        .then(cash => {
          // console.log(blce.data);

          this.dialog = true;
          this.searching = false;
          this.Cashes = cash.data;
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
    OnDepMoney() {
      if (this.$refs.MoneyDep.validate()) {
        this.clicked = true;
        this.ErrMsg = "";
        // this.cashDep.date = this.Current().date;
        this.cashDep.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/Reports/cash/DhigidHanti/withdraw",
            data: { Dhigid: this.cashDep },
          })
          .then(() => {
            this.cashDep.amountType = "";
            this.cashDep.Details = "";
            this.cashDep.Amount = 0;
            this.cashDep.date = "";

            this.$refs.MoneyDep.resetValidation();
            this.clicked = false;
            this.Onfinished();
          })
          .catch(error => {
            // console.log(error);
            this.ErrMsg = error && error.response && error.response.data;

            this.clicked = false;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      let andCon = v && v.replace(/,/g, "") > 0;
      return andCon || "Invalid Amount";
    },
  },
  created() {
    this.cashDep.date = this.Current().date;
  },
};
</script>
